// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"5c95f567","80":"d9a8601a","380":"a9722805","453":"a362da1a","480":"3b12dc9f","544":"e4ea72ec","562":"6ab8ce58","648":"99afc85e","683":"c2a934cc","716":"87c0bac0"}[chunkId] + ".chunk.js";
};